import { Injectable } from '@angular/core';

interface Overlay extends HTMLElement {
  open: boolean;
}

@Injectable({ providedIn: 'root' })
export class OverlayCoordinatorService {
  private static readonly OVERLAY_SELECTOR = 'odl-menu, odl-popover';
  private static readonly STRAY_FOCUS_SUPPRESSION_MS = 300;

  constructor() {
    document.addEventListener(
      'odl-before-open',
      (event) => {
        OverlayCoordinatorService.closeUnrelatedOverlays(event);
      },
      true,
    );
    document.addEventListener(
      'odl-before-close',
      () => {
        OverlayCoordinatorService.suppressStrayFocusEvents();
      },
      true,
    );
  }

  private static closeUnrelatedOverlays(event: Event): void {
    const opening = event.target;
    if (
      !(opening instanceof Element) ||
      !opening.matches(OverlayCoordinatorService.OVERLAY_SELECTOR)
    ) {
      return;
    }

    const overlays = document.querySelectorAll<Overlay>(OverlayCoordinatorService.OVERLAY_SELECTOR);
    const unrelatedOpenOverlays = Array.from(overlays).filter(
      (overlay) =>
        overlay.open &&
        overlay !== opening &&
        !overlay.contains(opening) &&
        !opening.contains(overlay),
    );
    unrelatedOpenOverlays.forEach((overlay) => {
      overlay.open = false;
    });
  }

  private static suppressStrayFocusEvents(): void {
    const swallow = (focusEvent: FocusEvent): void => {
      focusEvent.stopImmediatePropagation();
    };
    document.addEventListener('focusin', swallow, true);
    setTimeout(() => {
      document.removeEventListener('focusin', swallow, true);
    }, OverlayCoordinatorService.STRAY_FOCUS_SUPPRESSION_MS);
  }
}
